import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { constants } from '@app/@shared/constants';
import { PolicyData } from '@app/@shared/interfaces/policy.interface';
import { PolicyService } from '@app/@shared/services/policy.service';
import { IconDefinition, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

interface PolicyStore {
  paymentSchedule?: any;
  [policyId: string]: PolicyData;
}

@Component({
  selector: 'app-policy',
  templateUrl: './policy.component.html',
  styleUrls: ['./policy.component.scss'],
  standalone: false,
})
export class PolicyComponent implements OnInit {
  stateIcon: IconDefinition = faExclamationCircle;
  policyId: string;
  currentToken: string;
  migrationDate: any = constants.paymentusMigrationDate;
  updateDateFlag: boolean = false;
  paymentOption: boolean = false;
  product: string;
  polStatus: string;
  policyData: any; //PolicyData;
  policyDates: any;
  policyStore: any = {}; //PolicyStore = {};
  addressString: string;
  downloading: boolean = false;
  policyReady: boolean = false;

  constructor(private route: ActivatedRoute, private router: Router, private policyService: PolicyService) {
    this.route.paramMap.subscribe((routeParams) => {
      // const routeParams = this.route.snapshot.paramMap;
      this.policyId = routeParams.get('policyid');
      this.product = routeParams.get('product');

      if (this.policyStore && this.policyStore.hasOwnProperty(this.policyId)) {
        this.policyData = this.policyStore[this.policyId];
        this.setGeneratedData();
        this.setFlagType(this.migrationDate);
        this.policyReady = true;
      } else {
        this.policyData = null;

        this.policyService.getPolicy(this.policyId, this.product).subscribe((policyData) => {
          this.policyData = policyData;
          this.polStatus = this.policyData.responseJSON.policy.locked;
          this.policyStore[this.policyData.policy.policyId] = policyData;
          this.getPolicyBillingInquiry();
          this.setGeneratedData();
          this.setFlagType(this.migrationDate);
        });
      }

      this.policyService.getListProfile(this.policyId).subscribe((policyData) => {
        console.log('policyId', policyData);
        this.currentToken = policyData.token;
      });
    });
  }

  ngOnInit(): void {}
  dateFormatChg(date: any) {
    if (!date) {
      return NaN;
    }

    if (date instanceof Date) {
      return date.getTime();
    }

    if (typeof date === 'number') {
      return date;
    }

    if (typeof date === 'string') {
      if (date.includes('/')) {
        const parts = date.split('/');
        const parsedDate = new Date(parts[0] + '/' + parts[1] + '/' + parts[2]);
        return parsedDate.getTime();
      }

      const parsedDate = new Date(date);
      return parsedDate.getTime();
    }

    return new Date(date).getTime();
  }

  private parseBillingDate(dateValue: any): Date | null {
    if (!dateValue) {
      return null;
    }

    if (dateValue instanceof Date) {
      return Number.isNaN(dateValue.getTime()) ? null : dateValue;
    }

    const rawDate = String(dateValue).trim();
    const ymdMatch = /^(\d{4})-(\d{2})-(\d{2})/.exec(rawDate);

    if (ymdMatch) {
      const year = Number.parseInt(ymdMatch[1], 10);
      const month = Number.parseInt(ymdMatch[2], 10);
      const day = Number.parseInt(ymdMatch[3], 10);
      const parsed = new Date(year, month - 1, day);
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    }

    const fallbackParsed = new Date(rawDate);
    return Number.isNaN(fallbackParsed.getTime()) ? null : fallbackParsed;
  }

  getPolicyBillingInquiry() {
    this.policyService.getPaymentSchedule(this.policyData).subscribe((data) => {
      // console.log('schedule installments', data);

      this.policyReady = true;

      let installments = {
        paid: [] as any[],
        upcoming: [] as any[],
      };

      if (
        data?.responseTransactionSchedule?.TransactionResponse?.TransactionDetail[0]
          ?.InstallmentScheduleSummarybyDueDate
      ) {
        let paymentSummary =
          data.responseTransactionSchedule.TransactionResponse.TransactionDetail[0]
            ?.InstallmentScheduleSummarybyDueDate;

        for (let i = 0; i < paymentSummary.length; i++) {
          const payment = paymentSummary[i];
          // console.log('payment', payment);
          for (let n = 0; n < payment.TransactionReceivableSummary.length; n++) {
            const installment = payment.TransactionReceivableSummary[n];
            const rawBillDate =
              installment.InstallmentNo === '0'
                ? installment.PolicyEffectiveDate
                : payment.BillDueDate || installment.BillDueDate || installment.PolicyEffectiveDate;

            installment.BillDueDateObj = this.parseBillingDate(rawBillDate);

            if (installment.Balance > 0) {
              installments.upcoming.push(installment);
            } else {
              installments.paid.push(installment);
            }
          }
        }

        //Sort the array by sequence
        installments.upcoming.sort((a, b) => {
          const aNo = Number.parseInt(a.InstallmentNo, 10);
          const bNo = Number.parseInt(b.InstallmentNo, 10);
          return aNo - bNo;
        });
        installments.paid.sort((a, b) => {
          const aNo = Number.parseInt(a.InstallmentNo, 10);
          const bNo = Number.parseInt(b.InstallmentNo, 10);
          return aNo - bNo;
        });

        //in HTML loop installments

        this.policyData.paymentSchedule = installments;
        this.policyStore[this.policyData.policy.policyId] = this.policyData;

        // console.log('installments', installments);

        // this.policyService.getBillingInquiry(this.policyData).subscribe((inquiry) => {
        //   // console.log(
        //   //   'inquiry installments',
        //   //   inquiry.BillingInquiryOutput.BillingInquirySummary[0].BillingInquiryInstallments
        //   // );
        //   // console.log(
        //   //   'inquiry BillingInquiryTransactions',
        //   //   inquiry.BillingInquiryOutput.BillingInquirySummary[0].BillingInquiryTransactions
        //   // );
        //   this.policyData.billingInquiry = inquiry;
        //   this.policyStore[this.policyData.policy.policyId] = this.policyData;

        //   this.policyReady = true;

        // });
      }
    });
  }
  setFlagType(migrationDate: any) {
    let policyEffDate = this.policyData.policy.policyEffectiveDate;
    // console.log('int', policyEffDate);
    // console.log('int2', migrationDate);
    policyEffDate = this.dateFormatChg(policyEffDate);
    migrationDate = this.dateFormatChg(migrationDate);

    if (Number.isNaN(policyEffDate) || Number.isNaN(migrationDate)) {
      this.updateDateFlag = false;
      return;
    }

    if (migrationDate <= policyEffDate) {
      this.updateDateFlag = true;
    } else {
      this.updateDateFlag = false;
    }

    // console.log('date1', policyEffDate);
    // console.log('date2', migrationDate);
    // console.log('dateFlag', this.updateDateFlag);
  }

  setGeneratedData() {
    let policyEffDate = new Date(this.policyData.policy.policyEffectiveDate);
    let policyExpDate = new Date(this.policyData.policy.policyExpirationDate);
    let policyRetroDate = this.policyData.policy.retroactiveDate
      ? new Date(this.policyData.policy.retroactiveDate)
      : undefined;
    // console.log('pp', policyEffDate.toISOString().split('T').shift());
    this.policyDates = {
      effectiveDate: policyEffDate.toISOString().split('T').shift(),
      expirationDate: policyExpDate.toISOString().split('T').shift(),
      retroactiveDate: policyRetroDate ? policyRetroDate.toISOString().split('T').shift() : '',
    };

    // this.policyStore = {
    //   total: parseFloat(this.policyData.policy.policyITDPremium),
    //   dueToday: parseFloat(this.policyData.policy.policyITDPremium),
    //   effectiveDate: policyEffDate.toISOString().split('T').shift(),
    //   expirationDate: policyExpDate.toISOString().split('T').shift(),
    //   retroactiveDate: policyRetroDate ? policyRetroDate.toISOString().split('T').shift() : '',
    //   paymentProposal: this.policyData?.policy?.paymentPlanCd ? this.policyData.policy.paymentPlanCd : '1PAY',
    //   policyData: this.policyData,
    //   product: product,
    // };
    const addressDto = this.policyData.policy.addressDto;
    this.addressString = `${addressDto.insuredAddressStreetLine1Txt}, ${addressDto.insuredAddressCityTxt}, ${addressDto.insuredAddressStateCd} ${addressDto.insuredAddressPostalCd}`;
  }

  downloadPolicy() {
    return () => {
      if (!this.downloading) {
        this.downloading = true;
        this.policyService.downloadPolicy(this.policyData).subscribe((resultBytes) => {
          var blob = new Blob([resultBytes], { type: 'application/pdf' });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `arch-policy-${this.policyData.policy.policyId}.pdf`;
          link.click();

          this.downloading = false;
        });
      }
    };
  }
  close() {
    this.paymentOption = false;
  }
  updateExistCard() {
    if (this.product === 'ea') {
      this.router.navigate(['payment/check/policy/' + this.product + '/' + this.policyId]);
    } else {
      this.router.navigate(['payment/update-card/policy/' + this.product + '/' + this.policyId], {
        state: { paymentMode: this.updateDateFlag, listToken: this.currentToken, AddMethod: false },
      });
    }
  }
  AddNewCard() {
    if (this.product === 'ea') {
      this.router.navigate(['payment/check/policy/' + this.product + '/' + this.policyId]);
    } else {
      this.router.navigate(['payment/update-card/policy/' + this.product + '/' + this.policyId], {
        state: { paymentMode: this.updateDateFlag, AddMethod: true },
      });
    }
  }
  updateCreditCard() {
    return () => {
      if (!this.updateDateFlag) {
        if (this.product === 'ea') {
          this.router.navigate(['payment/check/policy/' + this.product + '/' + this.policyId]);
        } else {
          this.router.navigate(['payment/update-card/policy/' + this.product + '/' + this.policyId], {
            state: { paymentMode: this.updateDateFlag },
          });
        }
      } else if (this.updateDateFlag) {
        this.paymentOption = true;
      }
    };
  }
}
